import React from 'react';
import { Navbar } from 'react-bootstrap';
import Socials from './Socials';
import { Link } from 'react-router-dom';

function Footer() {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <Navbar bg="clear" variant="light" className="footer">
      <div className="inner2 w100">
        <Socials size={3} />
        <Navbar.Text>Email: hello@wesamtechnologies.com</Navbar.Text>
        <Navbar.Text>© Copyright {year}</Navbar.Text>
        <Navbar.Text>Wesam Technologies LLC</Navbar.Text>
        <Link
          to="/privacy"

        >
          <Navbar.Text href="/privacy" className="nav-link">
            Privacy Policy
          </Navbar.Text>
        </Link>
      </div>
    </Navbar>
  );
}

export default Footer;
